import React from 'react';
import { Grid } from '@material-ui/core';
import { RoutedTabs } from '@backstage/core-components';
import { MLModelOverview } from './MLModelOverview';
import { MLModelVersions } from './MLModelVersions';
import { MLModelDeploy } from './MLModelDeploy';
import { useMLFlowStyles } from './styles';
import { useModelDeployment } from './hooks';
import { transformVersionsToOptions } from '../../utils/transforms';
import { MLFlowModelDetailProps } from './types';

export const MLFlowContent = ({
  mlFlowModelDetail,
  entity,
}: MLFlowModelDetailProps) => {
  const classes = useMLFlowStyles();
  
  const {
    selectedDevice,
    setSelectedDevice,
    deviceInput,
    setDeviceInput,
    deploying,
    deployResult,
    isDeployDisabled,
    handleDeployModel,
    selectedVersion,
    setSelectedVersion,
    versionInput,
    setVersionInput,
  } = useModelDeployment(entity);

  return (
    <Grid item className={classes.mlFlowContainer}>
      <RoutedTabs
        routes={[
          {
            title: 'Overview',
            path: 'overview',
            children: <MLModelOverview mlFlowModelDetail={mlFlowModelDetail} />,
          },
          {
            title: 'Versions',
            path: 'versions',
            children: <MLModelVersions versions={mlFlowModelDetail.versions} />,
          },
          {
            title: 'Deploy',
            path: 'deploy',
            children: (
              <MLModelDeploy
                devices={mlFlowModelDetail.devices}
                modelVersions={transformVersionsToOptions(mlFlowModelDetail.versions || [])}
                selectedDevice={selectedDevice}
                deviceInput={deviceInput}
                selectedVersion={selectedVersion}
                versionInput={versionInput}
                deploying={deploying}
                deployResult={deployResult}
                isDeployDisabled={isDeployDisabled}
                onDeviceInputChange={setDeviceInput}
                onDeviceChange={setSelectedDevice}
                onVersionInputChange={setVersionInput}
                onVersionChange={setSelectedVersion}
                onDeploy={handleDeployModel}
              />
            ),
          },
        ]}
      />
    </Grid>
  );
};
